<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="500"
    >
      <v-card-title>
        {{ loading ?
          $t("Processing cancellation...") :
          (errorMessage ? $t("Error") :
            $t("Session Canceled"))
        }}
      </v-card-title>
      <v-card-text>
        <template v-if="!loading">
          <p v-if="!errorMessage">{{ $t("The session has been canceled successfully.") }}</p>
          <p
            v-else
            class="error-text"
          >
            {{ errorMessage }}
          </p>
        </template>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="my-4"
        ></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'StripeCancel',
  data() {
    return {
      sessionId: this.$route.query.session_id,
      loading: true,
      token: this.$route.query.hash,
      errorMessage: '', // To store any error message
    };
  },
  mounted() {
    if (this.sessionId) {
      this.cancelSession(this.sessionId);
    }
  },
  methods: {
    async cancelSession(sessionId) {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/stripe/cancel-checkout-session`, {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (response.data.redirectUrl) {
          // Wait a bit and then redirect
          setTimeout(() => {
            this.loading = false;
            window.location.href = response.data.redirectUrl;
          }, 2000);
        }
      } catch (error) {
        console.error('Error canceling session:', error);
        this.errorMessage = error.response?.data?.message || this.$t('An unexpected error occurred while canceling the session.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
  font-weight: bold;
}
</style>
